/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { BasePriceFormatComponent } from '../base-price-format.component';
/**
 * @record
 */
export function ErrorMapping() { }
function ErrorMapping_tsickle_Closure_declarations() {
    /** @type {?|undefined} */
    ErrorMapping.prototype.priceFormatNegativeError;
    /** @type {?|undefined} */
    ErrorMapping.prototype.priceFormatMinValueError;
    /** @type {?|undefined} */
    ErrorMapping.prototype.priceFormatMaxValueError;
}
;
export class MatPriceFormatComponent extends BasePriceFormatComponent {
    constructor() {
        super(...arguments);
        this.errorMapping = {
            priceFormatNegativeError: 'Doesn\'t insert a negative price.',
            priceFormatMinValueError: 'Insert a price more than or equal to ${minPrice}',
            priceFormatMaxValueError: 'Insert a price less than or equal to ${maxPrice}',
        };
        this.error = '';
        this.numberMask = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        const /** @type {?} */ self = this;
        this.numberMask = createNumberMask(this.options);
        this.control.statusChanges.subscribe(status => {
            if (status === 'VALID' || !Object.keys(self.control.errors || {}).length) {
                self.error = '';
                return;
            }
            const /** @type {?} */ firstError = Object.keys(self.control.errors)[0];
            if (firstError === 'priceFormatMinValueError') {
                self.error = self.errorMapping[firstError].replace('${minPrice}', self.options.minValue);
            }
            else if (firstError === 'priceFormatMaxValueError') {
                self.error = self.errorMapping[firstError].replace('${maxPrice}', self.options.maxValue);
            }
            else {
                self.error = self.errorMapping[firstError];
            }
        });
    }
}
MatPriceFormatComponent.decorators = [
    { type: Component, args: [{
                selector: 'mat-price-format',
                template: "<mat-form-field> <input matInput type=\"tel\" [textMask]=\"{mask:numberMask}\" [formControl]=\"control\" [value]=\"_price\" [readonly]=\"readonly\" [ngClass]=\"options.cssclass\" [placeholder]=\"options.placeholder\" (keyup)=\"handleKeyboardKeyUp($event)\" (keydown)=\"handleKeyboardKeyDown($event)\" (focusout)=\"focusOutEvent()\" (focusin)=\"focusInEvent()\"/> <mat-error>{{error}}</mat-error> </mat-form-field> ",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MatPriceFormatComponent), multi: true },
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => MatPriceFormatComponent), multi: true }
                ]
            },] },
];
/** @nocollapse */
MatPriceFormatComponent.propDecorators = {
    "control": [{ type: Input },],
    "errorMapping": [{ type: Input },],
};
function MatPriceFormatComponent_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    MatPriceFormatComponent.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    MatPriceFormatComponent.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    MatPriceFormatComponent.propDecorators;
    /** @type {?} */
    MatPriceFormatComponent.prototype.control;
    /** @type {?} */
    MatPriceFormatComponent.prototype.errorMapping;
    /** @type {?} */
    MatPriceFormatComponent.prototype.error;
    /** @type {?} */
    MatPriceFormatComponent.prototype.numberMask;
}
